import { js_utils } from "../frfr-js-utils";
import { tags_utils } from "../frfr-tags-utils";
import { _zzyourmap_config } from "./zz-yourmap-config";
import { _zzyourmap_lib_image_library_tags_default } from "./zz-yourmap-data-keys-and-values-lib";


// ----- yourmap image, image library utils


export const _zzyourmap_img_placeholder = _zzyourmap_config.img_placeholder_url_full;


//
export const _zzyourmap_img_url_full_from_parts = (img_filename, img_folder) => {
  // const img_url_full = _zzyourmap_config.BACKEND_URL_PREFIX + '/' + img_folder + '/' + img_filename;
  // let img_url_full = 'https://ymdemo2.applabz.work/test-assets/no-image-available.jpg';
  let img_url_full = _zzyourmap_img_placeholder;
  if (js_utils.is_string_not_empty(img_filename)) {
    // img_url_full = _zzyourmap_config.BACKEND_URL_PREFIX + '/' + img_folder + '/' + img_filename;
    img_url_full = _zzyourmap_config.BACKEND_URL_PREFIX + '/uploads/' + img_filename;
  }
  return img_url_full;
};


// * ne koristi se još TODO ???
export const _zzyourmap_img_url_full_from_rel = (img_url_rel) => {
  const img_url_full = _zzyourmap_config.BACKEND_URL_PREFIX + img_url_rel;
  return img_url_full;
};


//
export const _zzyourmap_prepare_image_library_entities = (arr) => {
  const entities = [];
  const entities_deleted = [];
  const tags_arr_all = [..._zzyourmap_lib_image_library_tags_default];
  const tags_arr_used = [];
  if (Array.isArray(arr)) {
    arr.forEach((item, index) => {
      if (item.flag_deleted === true) {
        // skip
      } else {
        if (typeof item.img_filename === 'string' && item.img_filename !== '' && typeof item.img_url_rel === 'string' && item.img_url_rel !== '') {
          /*
          let uploads_folder = '/';
          if (typeof item.img_folder === 'string' && item.img_folder !== '') {
            uploads_folder = '/' + item.img_folder + '/';
          }
          // TODO
          const img_url_rel = uploads_folder + item.img_filename;
          */
          const img_url_rel = item.img_url_rel;
          // const img_url_full = _zzyourmap_config.BACKEND_URL_PREFIX + img_url_rel;
          const img_url_full = _zzyourmap_img_url_full_from_rel(img_url_rel);
          const prepared_item = {
            ...item,
            img_url_rel,
            img_url_full,
          };
          if (prepared_item.flag_deleted === 1 || prepared_item.flag_deleted === true) {
            prepared_item.flag_deleted = true;
            entities_deleted.push(prepared_item);
          } else {
            if (prepared_item.tags_csv && typeof prepared_item.tags_csv === 'string') {
              const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(prepared_item.tags_csv);
              tags_arr.forEach(tag => {
                if (tags_arr_all.includes(tag)) {
                  // already added
                } else {
                  tags_arr_all.push(tag);
                }
                if (tags_arr_used.includes(tag)) {
                  // already added
                } else {
                  tags_arr_used.push(tag);
                }
              });
            }
            entities.push(prepared_item);
          }

        } else {
          // skip
        }
      }
    });
  }
  return [entities, entities_deleted, tags_arr_all, tags_arr_used];
};

